<template>
<body>
<h1>Demo for downloading/display PDF base64 string in IE, Chrome, Safari</h1>
</body>
</template>
<script>
import axios from 'axios';
import agreement from './Agreement.vue';
import pdf from './PreviewPDF.vue';
export default {
	components:{
		agreement,
		pdf
	},
	data() {
		return {
			agreemetformdata: {
				revenue_share: '',
				period_to_send_rev_pub: '',
				rev_dist_clarity_example :'',
				termination_duration_for_pub : '',
			},
			agreementDoc : ""
		}
			// message: '',
			// countryOptions: [],
			// currenciesOptions: []
	},
	methods: {
			submit(){
					var agreementDoc = document.getElementById("agreementform").innerHTML;
					// console.log("string_to_convert_blob",string_to_convert_blob)
					// var blobdata2 = new Blob([string_to_convert_blob], {type : 'text/html'});
					// //console.log(blobdata2)
					//
					// let formData = new FormData();
					// formData.append('text', blobdata2);
					// formData.append('revenueshare', this.agreemetformdata.revenue_share);
					// let json = {"blobdata2" : blobdata2}
					let x = {

							'revenueShare' : this.agreemetformdata.revenue_share,
							'periodToSendRevPub' : this.agreemetformdata.period_to_send_rev_pub,
							'revDistClarityExample' : this.agreemetformdata.rev_dist_clarity_example,
							'terminationDurationForPub' : this.agreemetformdata.termination_duration_for_pub,
							 'agreementDoc' : agreementDoc


					}

					console.log(x)

					// var test = "test string"
					axios.post(BASE_URL + 'v1/signNowApi/', x ,
					{
						headers:{
							'Content-Type': 'multipart/form-data; boundary=${data._boundary}',
						}
					}).then((response)  =>  {
								console.log(response)
					}, (error)  =>  {
								console.log("Error")
					})
					// var html_ele = document.getElementById("agreementform");
			},

			previewPDF(){

				var agreementDoc = document.getElementById("agreementform").innerHTML;
				// console.log("string_to_convert_blob",string_to_convert_blob)
				// var blobdata2 = new Blob([string_to_convert_blob], {type : 'text/html'});
				// //console.log(blobdata2)
				//
				// let formData = new FormData();
				// formData.append('text', blobdata2);
				// formData.append('revenueshare', this.agreemetformdata.revenue_share);
				// let json = {"blobdata2" : blobdata2}
				let x = {

						'revenueShare' : this.agreemetformdata.revenue_share,
						'periodToSendRevPub' : this.agreemetformdata.period_to_send_rev_pub,
						'revDistClarityExample' : this.agreemetformdata.rev_dist_clarity_example,
						'terminationDurationForPub' : this.agreemetformdata.termination_duration_for_pub,
						 'agreementDoc' : agreementDoc


				}

				console.log(x)

				// var test = "test string"
				axios.post(BASE_URL + 'v1/GeneratePDF/', x ,
				{
					headers:{
						'Content-Type': 'multipart/form-data; boundary=${data._boundary}',
					}
				}).then((response)  =>  {
					this.$notify({
						title: 'Success',
						message: 'Successfully created a new publisher',
						type: 'success'
					});

					setTimeout(() => {
						// this.$router.push('/admin/create-domain/?publisher='+response.data.id);
						this.$router.push('/admin/publisher/PreviewPDF')
					}, 1000);

				}, (error)  =>  {
							console.log("Error")
				})


			}



		}

}
</script>
<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.el-select{
	display: block;
}
.content-wrapper .content{
	padding-top: 95px;
}
button[disabled=disabled], button:disabled {
	background-color: rgba(200,200,200,2.3);
	cursor: not-allowed;
	border-color: rgba(200,200,200,2.3);
}
</style>



// WEBPACK FOOTER //
// PreviewPDF.vue?2b8e00d8